import React from 'react'
import ConfirmModal from 'support/modals/Confirm'
import { useWillPipe } from '@morningtrain/react-helpers'

export default function ConfirmPipe (props) {
  const modalRef = React.useRef()

  useWillPipe((payload) => {
    return new Promise((resolve, reject) => {
      if (!modalRef || !modalRef.current) {
        return reject('Unable to trigger confirm modal - ref was falsy')
      }

      modalRef.current.confirm()
        .then(() => {
          resolve(payload)
        })
        .catch((err) => {
          reject(err)
        })
    })
  })

  return (
    <ConfirmModal ref={modalRef} {...props} useOperation={false}>
      {props.children}
    </ConfirmModal>
  )
}
